import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/ui/buttons/Button';
import { IconShow } from '@shared/icons/IconShow';

type ShowPictureButton = { url: string; onClick: () => void };

export const ShowPictureButton = (props: ShowPictureButton) => {
  const { t } = useTranslation();

  return (
    <Button
      as="button"
      variant="secondary"
      size="tiny"
      icon={IconShow}
      iconClassName="mr-3"
      className="inline-flex text-center whitespace-nowrap"
      // @ts-ignore
      onClick={(e: MouseEvent) => {
        e.stopPropagation();

        props.onClick();
      }}
    >
      {t('show-picture')}
    </Button>
  );
};
